let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4BJSo")).then(() => parcelRequire('dmRPN'));